import { $set } from '@makeabledk/vue-ui/support/helpers'
import EventBus from './EventBus'
import FormErrors from './FormErrors'

export default class Form {
    constructor(data = {}) {
        if (data instanceof Form) {
            data = data.data()
        }

        this.submitFn = null
        this.events = new EventBus()
        this.errors = new FormErrors()
        this.isArray = Array.isArray(data)

        Object.assign(this, data)

        this.resetStatus()
    }

    static wrap(data) {
        return data instanceof Form ? data : new Form(data)
    }

    data() {
        let data = this.isArray ? [] : {}
        const ignore = Object.keys(new Form())

        Object.keys(this).forEach((key) => {
            if (ignore.indexOf(key) === -1) {
                data[key] = this[key]
            }
        })

        return data
    }

    setData(data) {
        if (data instanceof Form) {
            data = data.data()
        }

        Object.keys(this.data()).forEach((key) => {
            delete this[key]
        })

        this.fill(data)

        return this
    }

    fill(data) {
        Object.keys(data).forEach((key) => {
            $set(this, key, data[key])
        })

        return this
    }

    unset(index) {
        if (this.isArray) {
            let data = this.data()

            data.splice(index, 1)

            this.setData(data)
        } else {
            delete this[index]
        }

        return this
    }

    startProcessing() {
        this.errors.forget()
        this.setState(true, false)
        this.events.$emit('busy')
    }

    finishProcessing() {
        this.setState(false, true)
        this.events.$emit('success')
    }

    resetStatus() {
        this.errors.forget()
        this.setState(false, false)
    }

    setErrors(errors) {
        this.setState(false, this.successful)
        this.errors.set(errors)
        this.events.$emit('failure')
    }

    setState(busy, success) {
        this.busy = busy
        this.successful = success
        this.busyOrSuccessful = busy || success
    }

    submit() {
        if (!this.submitFn) {
            throw new Error('No submit function defined! Please use form.submitUsing() to define one.')
        }

        return this.submitFn(this).catch((error) => {
            if (!error.message.startsWith('The given data')) {
                throw error
            }
            return false
        })
    }

    submitUsing(submitFn) {
        this.submitFn = submitFn

        return this
    }
}
